import "./RoverVideo.scss"
import rover from "../../img/rover.jpg";

const RoverVideo = () => {
    return(
        <section className="RoverVideo">
            <img src={rover} alt="the Indomitus Rover"/>
            <div className="RoverVideo-ending-cap-txt">
                <div className="RoverVideo-ending-cap-txt-about">
                    <h3>INDOMITUS</h3>
                    <p>by UCU SPACE ROBOTICS</p>
                </div>
                <a className="RoverVideo-ending-cap-txt-a"
                   href="https://youtu.be/to2NTyvfPCk?si=ejru3UC6Sjzz5Tom" target="_blank" rel="noreferrer">
                    Watch us.
                </a>
            </div>
        </section>
    )
};
export default RoverVideo;